// Estado de los pacientes de un protocolo, tal como lo publica la API de protocolos
// GET /protocols/protocols/patients/status-statistics
// https://prebiller.hc.alpha-cr.com/apis/prebiller-gateway/swagger/docs/v1/protocols

/**
 * Glosario de estados del paciente en el protocolo, tal como lo define el backend
 * (`ProtocolPatientStatusEnum`). El spec publica sólo los números; los nombres
 * vienen de la definición del enum del lado de la API.
 */
export enum ProtocolPatientStatusEnum {
  Screening = 0,
  Random = 1,
  Treatment = 2,
  FollowUp = 3,
  ScreenFailure = 4,
  LostToFollowUp = 5,
  WithoutDrugs = 6,
  Discontinuation = 7,
  EndParticipationInProtocol = 8,
  PreScreening = 9
}

/**
 * Cuántos pacientes hay en un estado.
 *
 * `status` es un número del 0 al 9 sin nombres en el spec; el nombre legible viaja
 * al lado en `statusDescription`, que es lo que hay que mostrar. No se mantiene una
 * tabla propia de nombres porque la dueña del catálogo es la API: si cambia o
 * agrega un estado, la pantalla lo muestra bien sin tocar el front.
 */
export interface ProtocolPatientStatusCount {
  status: number;
  statusDescription?: string | null;
  count: number;
}

/**
 * Un paciente con su estado (GET .../patients/status-detail). Es el desglose de
 * las cifras de status-statistics: quién está en cada estado.
 */
export interface ProtocolPatientStatusDetail {
  protocolId: number;
  protocolNumber?: string | null;
  protocolTitle?: string | null;
  numberInProtocol?: string | null;
  medicalRecordNumber?: string | null;
  patientFullName?: string | null;
  status: number;
  statusDescription?: string | null;
  randomizationDate?: string | null;
}

/** Totales por estado de un protocolo. */
export interface ProtocolPatientStatusStatistics {
  protocolId: number;
  protocolNumber?: string | null;
  protocolTitle?: string | null;
  total: number;
  statuses?: ProtocolPatientStatusCount[] | null;
}
